module.exports = __webpack_public_path__ + "static/img/lun_8.583acc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_8.jpg
// module id = 8j/n
// module chunks = 1